// extracted by mini-css-extract-plugin
export default {"section":"news_section__NxmyR","box":"news_box__fzzA7","headline":"news_headline__WkY6C","text":"news_text__K3org"};